module.exports = __webpack_public_path__ + "static/Elemental_Fire-7cdfb6b49778a0ae02577bd2acbf5722.jpg";